__webpack_require__.p = "https://assets-01.periodica.press/85c8850-19329891158/";